import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'

const COLUMNS = [
  {
    heading: 'Explore',
    links: [
      { label: 'Events', to: '/events' },
      { label: 'Classes', to: '/events' },
      { label: 'Retreats', to: '/events' },
      { label: 'Practices', to: '/events' },
    ],
  },
  {
    heading: 'Community',
    links: [
      { label: 'WhatsApp', href: '#community' },
      { label: 'Daily check-ins', to: '/mid-day-reset' },
      { label: 'Stories', to: '/events' },
    ],
  },
  {
    heading: 'Partners',
    links: [
      { label: 'Facilitators', to: '/for-facilitators' },
      { label: 'Spaces', to: '/for-facilitators' },
      { label: 'Organizations', to: '/corporates' },
      { label: 'Energizers', to: '/energizers-june-cohort-signup' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '#' },
      { label: 'Contact', href: '#' },
      { label: 'Careers', href: '#' },
      { label: 'Press', href: '#' },
    ],
  },
]

function FooterLink({ link }) {
  const cls =
    'text-sm text-primary-100/80 transition-colors hover:text-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream/60 rounded'
  return link.href ? (
    <a href={link.href} className={cls}>
      {link.label}
    </a>
  ) : (
    <Link to={link.to} className={cls}>
      {link.label}
    </Link>
  )
}

function FooterColumn({ column }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="border-b border-primary-800 py-3 md:border-0 md:py-0">
      {/* Mobile: collapsible header */}
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        aria-expanded={open}
        className="flex w-full items-center justify-between text-left md:cursor-default md:pointer-events-none"
      >
        <span className="text-xs font-semibold uppercase tracking-wider text-cream">
          {column.heading}
        </span>
        <ChevronDown
          className={cn(
            'h-4 w-4 text-primary-200 transition-transform md:hidden',
            open && 'rotate-180'
          )}
        />
      </button>
      <ul
        className={cn(
          'flex-col gap-2.5 md:mt-4 md:flex',
          open ? 'mt-3 flex' : 'hidden'
        )}
      >
        {column.links.map((link) => (
          <li key={link.label}>
            <FooterLink link={link} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-cream">
      <div className="mx-auto max-w-[1200px] px-6 py-14 lg:px-20">
        <div className="grid gap-8 md:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div className="mb-2 md:mb-0">
            <p className="text-lg font-bold">Wellness Loop</p>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-primary-100/80">
              Building the connective layer for everyday wellbeing.
            </p>
          </div>
          {COLUMNS.map((column) => (
            <FooterColumn key={column.heading} column={column} />
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-primary-800 pt-6 text-sm text-primary-100/70 sm:flex-row">
          <span>© 2026 Wellness Loop</span>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-cream">Privacy</a>
            <a href="#" className="hover:text-cream">Terms</a>
            <a href="#" className="hover:text-cream">Instagram</a>
            <a href="#" className="hover:text-cream">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
